"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";

export function ProofSection() {
  return (
    <section className="bg-[#efecea] py-16 md:py-28">
      <div className="mx-auto flex max-w-7xl gap-8 md:gap-10 lg:gap-20">
        <div className="max-w-xl pt-12 pl-8">
          <p className="mb-6 text-xl font-medium tracking-widest text-neutral-900/90">
            The #1 software & app for beauty, wellness
          </p>
          <h1 className="mb-2 text-xl font-medium text-neutral-900 md:text-3xl lg:text-5xl">
            Built for every business & independent providers.
          </h1>
          <p className="text-base text-neutral-900/80 md:text-xl">
            Attract new clients and increase revenue with all-in-one
            software.{" "}
          </p>
          <Button
            className="bg-fe-primary hover:ring-fe-primary/50 hover:fe-primary mt-10 h-11 font-medium text-white hover:ring-4"
            asChild
          >
            <Link href="/signup">Try for free</Link>
          </Button>
          <Button
            className="mt-10 ml-6 h-11 bg-white text-neutral-900 hover:text-neutral-900"
            variant={"outline"}
            asChild
          >
            <Link href="/get-demo">Get a demo</Link>
          </Button>
        </div>
        <div className="relative">
          <div className="max-md:hidden">
            <img
              src="/images/landing_page/spa-4.png"
              className="h-[410px] rounded-4xl"
              alt=""
            />
          </div>
          {/*<div className="max-md:hidden absolute h-[390px] w-[450px] top-48 -right-80">*/}
          {/*    <img src="/images/landing_page/spa-5.jpg" className="h-full rounded-4xl" alt=""/>*/}
          {/*</div>*/}
        </div>
      </div>
    </section>
  );
}
